module.exports = __webpack_public_path__ + "fonts/Sarabun-ExtraLight.42d3e666.ttf";